import { createStore } from 'easy-peasy';

import storeModel from './models';

// const mainStore = createStore(storeModel); // for no redux devtools
const mainStore = createStore(storeModel, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default mainStore;
